<template>
  <vs-button
    :disabled="disabled || processing"
    @click="handleClick"
  >
    <slot />
  </vs-button>
</template>

<script>
export default {
  name: 'SingleSubmitButton',
  props: {
    text: {
      type: String,
      default: null
    },
    onclick: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      processing: false
    }
  },
  methods: {
    async handleClick (event) {
      if (this.processing) return
      this.processing = true
      setTimeout(() => {
        // 3秒後に有効に戻す
        this.processing = false
      }, 3000)
      await this.onclick(event)
    }
  }
}
</script>
